import LinkButton from "../LinkButton";
import "./FourOhFourPage.scss";

const FourOhFourPage = ({
  status = "404",
  message = "Page Not Found",
}: {
  status?: string;
  message?: string;
}) => {
  return (
    <div id="FourOhFour">
      <div>
        <h2>{status}</h2>
        <h4>{message}</h4>
        <div>
          <p>
            <a href="/">Click here to return to the homepage</a> or{" "}
            <LinkButton
              onClick={() => {
                window.history.back();
              }}
            >
              go back to the previous page.
            </LinkButton>
          </p>
          <p>
            Please contact{" "}
            <a href="mailto:support@pathologywatch.com">
              support@pathologywatch.com
            </a>{" "}
            if you think you've reached this page in error.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FourOhFourPage;
